import React from 'react';

const ServiceIcon = ({ type, className = '' }) => {
  const icons = {
    ux: (
      <svg viewBox="0 0 48 48" fill="none" className={className}>
        <circle cx="24" cy="24" r="22" stroke="currentColor" strokeWidth="2" />
        <circle cx="24" cy="24" r="14" stroke="currentColor" strokeWidth="2" />
        <circle cx="24" cy="24" r="6" fill="currentColor" />
      </svg>
    ),
    app: (
      <svg viewBox="0 0 48 48" fill="none" className={className}>
        <rect x="12" y="6" width="24" height="36" rx="3" stroke="currentColor" strokeWidth="2" />
        <line x1="12" y1="12" x2="36" y2="12" stroke="currentColor" strokeWidth="2" />
        <line x1="12" y1="36" x2="36" y2="36" stroke="currentColor" strokeWidth="2" />
        <circle cx="24" cy="40" r="2" fill="currentColor" />
      </svg>
    ),
    branding: (
      <svg viewBox="0 0 48 48" fill="none" className={className}>
        <circle cx="24" cy="16" r="8" stroke="currentColor" strokeWidth="2" />
        <path d="M16 28 L24 42 L32 28" stroke="currentColor" strokeWidth="2" fill="none" />
        <circle cx="24" cy="16" r="3" fill="currentColor" />
      </svg>
    ),
    webapp: (
      <svg viewBox="0 0 48 48" fill="none" className={className}>
        <rect x="6" y="10" width="36" height="28" rx="2" stroke="currentColor" strokeWidth="2" />
        <line x1="6" y1="18" x2="42" y2="18" stroke="currentColor" strokeWidth="2" />
        <circle cx="10" cy="14" r="1.5" fill="currentColor" />
        <circle cx="15" cy="14" r="1.5" fill="currentColor" />
        <circle cx="20" cy="14" r="1.5" fill="currentColor" />
      </svg>
    ),
    webdesign: (
      <svg viewBox="0 0 48 48" fill="none" className={className}>
        <circle cx="24" cy="24" r="18" stroke="currentColor" strokeWidth="2" />
        <ellipse cx="24" cy="24" rx="8" ry="18" stroke="currentColor" strokeWidth="2" />
        <line x1="6" y1="24" x2="42" y2="24" stroke="currentColor" strokeWidth="2" />
      </svg>
    )
  };

  return icons[type] || icons.ux;
};

export default ServiceIcon;
